import React, { ReactElement } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@bit/atd.web.button'
import colors from '@bit/atd.web.colors'
import Loader from '@bit/atd.web.loaders.base'

const useStyles = makeStyles({
  wrap: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    '& button ~ button': {
      marginLeft: '12px',
    },
  },
  bottom: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    zIndex: 3,
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '24px',
    borderTop: `1px solid ${colors.gray400}`,
    backgroundColor: colors.white,
  },
})

type PropsType = {
  /** Fixed position to the bottom of the viewport */
  bottom?: boolean
  submitButtonText?: string
  cancelButtonText?: string
  onCancel: (event: React.MouseEvent<HTMLButtonElement>) => void
  onSubmit: (event: React.MouseEvent<HTMLButtonElement>) => void
  isSubmitting?: boolean
}

const EditingAction = ({
  bottom,
  submitButtonText,
  cancelButtonText,
  onCancel,
  onSubmit,
  isSubmitting,
}: PropsType): ReactElement => {
  const classes = useStyles()
  return (
    <div className={clsx(classes.wrap, { [classes.bottom]: bottom })}>
      <Button
        variant="tertiary"
        // @ts-ignore
        onClick={onCancel}
      >
        {cancelButtonText || 'Cancel'}
      </Button>
      {!isSubmitting ? (
        <Button
          variant="primary"
          // @ts-ignore
          onClick={onSubmit}
        >
          {submitButtonText || 'Submit'}
        </Button>
      ) : (
        <Loader size={20} />
      )}
    </div>
  )
}

EditingAction.defaultProps = {
  bottom: false,
}

export default EditingAction
